import "./notFound.css"
import notFoundImg from "../../../assets/images/404.webp";


const NotFound = () => {

    return(
        <div className="not-found-container container-fluid d-flex align-items-center justify-content-center">
            <img src={notFoundImg} alt=" not found"/>
        </div>
    )
}


export default NotFound;